require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/define-properties.js
// module id = CJli
// module chunks = 0 28 29 32 33 34 39 45 46 107 108 109 110 111 112 113 115 116 122 123 124